// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"168":"f8e55c6da42c0f83","8187":"23ac3c50c1836f70"}[chunkId] + ".js";
};